module.exports = __webpack_public_path__ + "ATS/img/botton_取消.ac6e2307.svg";